import { Chip, ChipProps } from '@mui/material'
import { GroupResult } from 'interface/user/group'
import { UsersGroup } from 'interface/user'

type GroupChipProps = {
  group: UsersGroup | GroupResult
} & ChipProps
export const GroupChip = ({
  group,
  ...others
}: GroupChipProps) => {
  return <Chip {...others} label={group.groupName} variant="filled" color="default" />
}
